<template>

	<EmergencyWindow ref='_window'
		:options='{ type: "spinner" }'
		:actions='{ header: [], tray: [] }'
		:content='{ align: "center" }'>
		<div class='spinner-ui'>
			<div></div>
			<div><i class='fa fa-hourglass-half' /></div>
		</div>
	</EmergencyWindow>

</template>

<script setup>

	import { ref } from 'vue';
	import { tx } from '@/modules/i18n';

	import EmergencyWindow from '@/components/emergency/EmergencyWindow.vue';

	//

	const _window = ref();

	defineExpose( { Open, Close } );

	//

	function Open ()
	{
		_window.value.Open();
	}


	function Close ()
	{
		_window.value.Close();
	}

</script>
